import BaseListagem from "components/BaseListagem";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import AprovacaoFaixaValoresService from "service/administracao/cadastro/aprovacaofaixavalores/AprovacaoFaixaValoresService";

const aprovacaoFaixaValoresService = new AprovacaoFaixaValoresService();

export default function AprovacaoFaixaValoresListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Aprovação por Faixa de Valores');

    const defaultFilters: DataTableFilterMeta = {
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={aprovacaoFaixaValoresService} urlService="/aprovacaofaixavalores" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton={false} showNewButton={false} showRemoveButton={false} nome="aprovacaofaixavalores" >
            <Column
                field="tipoRotina" header="Tipo de rotina" showAddButton={false}
            />
        </BaseListagem>
    )
}
